import React, {useContext} from 'react';
import {AppCtx, ViewTypes} from "../../../AppCtx";
import {useLocation} from 'react-router-dom';
import {isSongbook} from '../../dashboard/component/dashboardData';
import {songPathFromUrl} from '../../../shared/services/songPathUtils';
import {useWorkspaceReadOnly} from '../../../shared/hooks/useWorkspaceReadOnly';
import {FaSearchMinus, FaSearchPlus} from 'react-icons/fa';

const btnStyle = {cursor:'pointer', borderRadius:'30%', padding:'5px', border:0, background:'transparent', color:'inherit', font:'inherit', display:'inline-flex'};
const labels = {app: 'ekranów aplikacji', song: 'tekstu pieśni', presentation: 'prezentacji'};

export default function FontSizeButtonsComponent({scope}) {
  const {pathname} = useLocation();
  const {zooms, setZoom, viewType, isPresentationMode} = useContext(AppCtx);
  const readOnly = useWorkspaceReadOnly();
  const songScreen = pathname.startsWith('/songs/') && isSongbook(songPathFromUrl(pathname));
  const activeScope = scope || (songScreen && isPresentationMode ? 'presentation'
    : songScreen && (readOnly || viewType === ViewTypes.SONGS) ? 'song' : 'app');

  return (<>
    <button type="button" onClick={() => setZoom(activeScope, s => s + 0.1)} disabled={zooms?.[activeScope] >= 3} style={btnStyle} title="Zwiększ rozmiar czcionki" aria-label={`Powiększ zoom ${labels[activeScope]}`}><FaSearchPlus/></button>
    <button type="button" onClick={() => setZoom(activeScope, s => s - 0.1)} disabled={zooms?.[activeScope] <= 0.5} style={btnStyle} title="Zmniejsz rozmiar czcionki" aria-label={`Pomniejsz zoom ${labels[activeScope]}`}><FaSearchMinus/></button>
  </>);
};
